import Arbo from '../blocs/arbo.vue'

export default {
	data() {
		return {}
	},
	props: ['params'],
	methods: {
		reset_filters(){
			this.$store.dispatch('resetDechets');
		},
		afficheModaleDechet(dechet_id){
			console.log(dechet_id);
		}
	},
	computed:{},
	watch: {},
	components: {
		Arbo
	}
}